import { Component, inject, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { NgxAimAdminEditCustomerDefaultComponent } from './edit-customer-default/ngx-aim-admin-edit-customer-default.component';
import { NgxAimAdminPrimengModule } from '../ngx-aim-admin.primeng.module';
import { AppLazyLoadEvent } from '../../../models';
import { HttpErrorService } from '../../../services';
import { MatchModesPrime } from '../../../enums';
import { NgxAimAdminCustomerDefaultsService } from './ngx-aim-admin-customer-defaults.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'ngx-aim-admin-customer-defaults',
  standalone: true,
  imports: [FormsModule, NgxAimAdminPrimengModule, AsyncPipe, NgClass],
  templateUrl: './ngx-aim-admin-customer-defaults.component.html',
  styleUrls: ['./ngx-aim-admin-customer-defaults.component.scss', '../admin.scss'],
  providers: [DialogService],
})
export class NgxAimAdminCustomerDefaultsComponent {
  entityService = inject(NgxAimAdminCustomerDefaultsService);
  dialogService = inject(DialogService);
  httpErrorService = inject(HttpErrorService);
  messageService = inject(MessageService);

  @ViewChild('dt') table: Table | undefined;
  data$ = this.entityService.data$;
  isLoading$ = this.entityService.isLoading$;
  dataCount$ = this.entityService.dataCount$;
  lastLazyLoadEvent: AppLazyLoadEvent = {
    globalFilterFields: [],
    filters: {}
  };
  selectedOptions: string[] = [];
  isSyncing = false;

  onLazyLoad($event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = $event;
    const lazyLoadEvent: AppLazyLoadEvent = Object.assign({
      withDeleted: this.selectedOptions.includes('withDeleted'),
      globalFilterFields: this.table?.globalFilterFields || [],
    }, $event);

    this.entityService.onFilterEvent(lazyLoadEvent);
  }

  applyFilterGlobal($event: Event) {
    this.table?.filterGlobal(($event.target as HTMLInputElement).value, MatchModesPrime.CONTAINS);
  }

  onSyncClick() {
    this.isSyncing = true;
    this.entityService.sync().subscribe({
      next: () => this.onSyncSuccess(),
      error: (err) => this.onSyncError(err, 'Could not sync customer defaults'),
    });
  }

  onSyncSuccess() {
    this.isSyncing = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Confirmed',
      detail: `Customer Defaults synced`,
      key: 'app-toast',
      life: 5000
    });
    this.onLazyLoad(this.lastLazyLoadEvent);
  }

  onSyncError(err: any, summary: string) {
    this.isSyncing = false;
    this.httpErrorService.onHttpError(err, summary);
  }

  openEntity(entityId?: number) {
    const dialog = this.dialogService.open(NgxAimAdminEditCustomerDefaultComponent, {
      data: entityId,
      header: 'Customer Default',
      width: '700px',
      contentStyle: { "max-height": "580px", "overflow": "auto" },
      dismissableMask: true
    });
    dialog.onClose.subscribe(() => {
      this.onLazyLoad(this.lastLazyLoadEvent);
    });
  }
}
